import { AppModule } from 'app/module';
import 'module/logo/main';
import { trackGa4 } from 'util/googleAnalytics';
import { user } from 'app/user';
import './styles.scss';

export class ApplyButton extends AppModule {
    domBindings() {
        return {
            button: '.m-applyButton__button',
            label: '.m-applyButton__label',
        };
    }

    getPropsFromDom() {
        return {
            applyUrl: this.dom.el.getAttribute('data-apply-url') ?? '',
            text: this.dom.label?.innerHTML ?? false,
            isSmartApplyJob: this.dom.el.getAttribute('data-is-smart-apply-job') === 'true',
            isSeamless: this.dom.el.getAttribute('data-is-seamless') === 'true',
            jobBundleLabel: this.dom.el.getAttribute('data-job-bundle-label'),
            isDisabled: this.dom.button ? this.dom.button.classList.contains('m-applyButton__button--disabled') : false,
            jobId: this.dom.el.getAttribute('data-job-id') ?? '',
        };
    }

    domEvents() {
        this.dom.button.addEventListener('click', (e) => this.buttonClicked(e));
    }

    buttonClicked(e) {
        if (e) e.preventDefault();

        trackGa4({
            event: 'job_apply_click',
            application_type: this.props.isSmartApplyJob ? 'SmartBewerben' : 'External',
            job_type: this.props.isSeamless ? 'SJA' : 'Standard',
            job_id: this.props.jobId ?? null,
            product_type: this.props.jobBundleLabel ?? null,
            method: 'Ad Header',
            user_data: {
                email: user.getUserMail(),
            },
        });

        if (!this.props.error && !this.props.isDisabled) {
            this.events.emit('submitClicked');
        }
    }

    redirectToApplyForm() {
        window.open(this.props.applyUrl, '_blank', 'noopener');
    }
}
